import { Component, OnInit} from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Device } from 'src/app/assabil-kernel/models/entities/control-tables/device';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
@Component({
    selector: 'device-lov',
    templateUrl: './device-lov.component.html',
    styleUrls: ['./device-lov.component.scss']
})


export class DeviceLovComponent extends GenericLovComponent {

    code         : string; 
    name         : string; 

    devices                 : Device[] = [];

    columns = [
        {  prop: 'deviceSerialNumber', name: 'N° Serie'}
    ]


//----------------------------------------------------------------------
constructor(
    public dialogRef: MatDialogRef<DeviceLovComponent>,
        protected controlTablesService  : ControlTablesService) {
            super();
            this.entityName = "device";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.devices = result;
    })
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
closeModal(device : Device){
    this.dialogRef.close(device);
}
//----------------------------------------------------------------------

}
